import { WECHAT_SHARE_DEFAULT_PARAMS } from '@/utils/constant';
import { isAndroid, isIOS } from '@/utils/index';
import pageShare from '@/utils/page-share';
import wechat from '@/utils/share/wechat-plugin';

// 落地页
let landingPage = '';

/**
 * 初始化微信设置
 */
function initWechatSettings() {
  wechat.setDefaultParams(WECHAT_SHARE_DEFAULT_PARAMS);
  wechat.config();
}

/**
 * 更改微信分享参数
 */
function setDefaultPageShareParams() {
  const params = {
    qZoneParams: WECHAT_SHARE_DEFAULT_PARAMS,
    qqParams: WECHAT_SHARE_DEFAULT_PARAMS,
    weiboParams: WECHAT_SHARE_DEFAULT_PARAMS,
    wxFriendsParams: WECHAT_SHARE_DEFAULT_PARAMS,
    wxTimelineParams: WECHAT_SHARE_DEFAULT_PARAMS,
  };
  wechat.changeShareParams(params);
}

/**
 * 设置微信配置
 */
export function setWechatConfig() {
  // iOS 仅需在页面第一次加载时进行初始化
  const needToInitIOS = isIOS() && landingPage === '';
  const needToInitAndroid = isAndroid();
  if (needToInitIOS || needToInitAndroid) {
    // 初始化微信设置
    initWechatSettings();
  }
  // 更改微信分享配置
  setDefaultPageShareParams();
  if (needToInitIOS) {
    // 更新landingPage
    [landingPage] = window.location.href.split('#');
  }
}

/**
 * 更新微信分享信息
 */
export function updateWechatShareInfo() {
  const path = window.location.href;
  // 获取已缓存页面分享信息
  const item = pageShare.get(path);
  if (item) {
    // 设置微信分享信息
    wechat.changeShareParams(item.share);
  }
}

/**
 * 更新页面分享信息
 * @param info
 */
export function changePageShareInfo(info) {
  const path = window.location.href;
  const item = {
    path,
    share: { ...info },
  };
  // 缓存页面微信分享信息
  pageShare.add(item);
  // 更新微信分享信息
  updateWechatShareInfo();
}
